import { createSelector } from '@reduxjs/toolkit'

const getDividendsAndInterestSummary = (state) => state.dividendsAndInterestSummary
const getDividends = (state) => state.dividends
const getDividendsItems = (state) => state.dividends.items
const getBankAccountIncomes = (state) => state.bankAccountIncomes
const getBankAccountIncomesItems = (state) => state.bankAccountIncomes.items
const pluckId = (_state, { id }) => id

export const getBankAccountIncomeById = createSelector(
    [getBankAccountIncomesItems, pluckId],
    (bankAccountIncomes, bankAccountIncomeId) =>
        bankAccountIncomes.find((bankAccountIncome) => bankAccountIncome.id === bankAccountIncomeId)
)

export const getDividendById = createSelector([getDividendsItems, pluckId], (dividends, dividendId) =>
    dividends.find((dividend) => dividend.id === dividendId)
)

export default createSelector(
    [getDividendsAndInterestSummary, getDividends, getBankAccountIncomes],
    (dividendsAndInterestSummary, dividends, bankAccountIncomes) => ({
        bankAccountIncomes,
        dividends,
        dividendsAndInterestSummary,
        dividendsAndInterestSummaryStatus: dividendsAndInterestSummary.status,
        hasDividendsAndInterestSummary: !!dividendsAndInterestSummary.taxReturnId,
    })
)
